import { InvoiceInterface } from '../../../../interfaces/invoice.interface';
import { ProductInOrder } from '../../../../interfaces/product.interface';
import { DocViewProductsList } from './DocViewProductsList';
import { DocViewProductsTable } from './DocViewProductsTable';

interface Props {
  doc: InvoiceInterface;
  products: ProductInOrder[];
  docHasVatExceptionCategory?: boolean;
}

export const DocViewProductsSection = ({ doc, products, docHasVatExceptionCategory = false }: Props) => {
  return (
    <div className="flex-start-start-column-nowrap width100">
      <div className="width100">
        <DocViewProductsTable doc={doc} />
      </div>
      <div className="width100">
        <DocViewProductsList products={products} docHasVatExceptionCategory={docHasVatExceptionCategory} />
      </div>
    </div>
  );
};
